import { render } from "./BlListFilterSelectWorkflow.vue?vue&type=template&id=48be4384&scoped=true"
import script from "./BlListFilterSelectWorkflow.vue?vue&type=script&lang=js"
export * from "./BlListFilterSelectWorkflow.vue?vue&type=script&lang=js"

import "./BlListFilterSelectWorkflow.vue?vue&type=style&index=0&id=48be4384&scoped=true&lang=scss"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48be4384"]])

export default __exports__